// Typed environment-variable accessor for apps/web (TASK-N51).
//
// Reads from `import.meta.env`, which Vite inlines at build time. Vars
// must start with `VITE_` to be exposed to the client bundle (see
// https://vite.dev/guide/env-and-mode). Build-mode-aware defaults keep
// dev frictionless without requiring a `.env.local` file; production
// builds should override via the deploy pipeline.
//
// Usage:
//   import { env } from "../lib/env.js";
//   const url = env.adminUrl;
//
// Adding a var: declare it on `Env`, add the resolver below, augment
// `ImportMetaEnv` in `src/vite-env.d.ts`, and document it in
// `apps/web/.env.example`.

const isProd = import.meta.env.MODE === "production";

export interface Env {
  /** URL of the apps/admin portal (super_admin destination per ADR-007). */
  adminUrl: string;
}

export const env: Env = {
  adminUrl:
    import.meta.env.VITE_ADMIN_URL ??
    (isProd ? "https://admin.hcm.nsofar.com" : "http://localhost:3001"),
};
